export default __webpack_public_path__ + "assets/wind-beaufort-5.237d4abf.svg";